import 'picturefill';
import cookieConsent from './cookieConsent';
import inputFile from './custom-file-input';
import videolink from './videolink';
import sliders from './sliders';
import contact from './contact';
import candidate from './candidate';
import candidatePro from './candidatePro';

document.addEventListener('DOMContentLoaded', () => {

});

(function ($) {
    $(function () {

    });
})(jQuery);


$(document).ready(function () {
    console.log('front');
    cookieConsent();
    inputFile();
    videolink();
    sliders();
    contact();
    candidate();
    candidatePro();

    $.fn.select2.defaults.set("templateSelection", function (tag, container){
        var $option = $(tag.element);
        if ($option.attr('toogle-title')) {
            var title = $option.attr('toogle-title');
            $(container).attr('data-original-title', title);
            $(container).tooltip();
        }
        return tag.text;
    });

    $.fn.select2.defaults.set("templateResult", function (style){
        var originalOption = $(style.element).clone();
        var title = $(style.element).attr('toogle-title');
        $(originalOption).tooltip({'title': title});
        return originalOption;
    });



    $(document).off('click.bs.tab.data-api', '.tabs-pp [data-hover="tab"]');
    $(document).on('mouseenter.bs.tab.data-api', '.tabs-pp [data-toggle="tab"], .tabs-pp [data-hover="tab"]', function () {
        $(this).tab('show');
    });

    if($().owlCarousel !== undefined) {
        $(document).off('click.bs.tab.data-api', '.directions-pp [data-hover="tab"]');
        $(document).on('mouseenter.bs.tab.data-api', '.directions-pp [data-toggle="tab"], .directions-pp [data-hover="tab"]', function () {
            $(this).tab('show');

            var testimonials = $(" .active .testimonials-carousel");
            testimonials.owlCarousel({
                autoplay: true,
                loop: true,
                nav: false,
                dot: true,
                autoplayTimeout: 7000,
                items: 1,
            });

        });

        var testimonials = $(" .active .testimonials-carousel");
        testimonials.owlCarousel({
            autoplay: true,
            loop: true,
            nav: false,
            dot: true,
            autoplayTimeout: 7000,
            items: 1,
        });

    }


    //********** Scroll  ***************************************//
    $('.js-scrollTo').on('click', function () {
        var goscroll = false;
        var the_hash = $(this).attr("href");
        var regex = new RegExp("(.*)\#(.*)", "gi");
        var the_element = '';
        if (the_hash.match("\#(.+)")) {

            the_hash = the_hash.replace(regex, "$2");
            if ($("#" + the_hash).length > 0) {
                the_element = "#" + the_hash;
                goscroll = true;
            }
            else if ($("a[name=" + the_hash + "]").length > 0) {
                the_element = "a[name=" + the_hash + "]";
                goscroll = true;
            }

            if (goscroll) {
                var headerHeight = $('header').outerHeight();
                var to = $(the_element).offset().top - headerHeight - 20;
                $('html, body').animate({
                    scrollTop: to
                }, 750);
                return false;
            }
        }
    });




    window.onscroll = function() {scrollFunction()};


    function scrollFunction() {
        var posScroll = $(document).scrollTop();
        if(posScroll >= 50)
        {
            $('.scroll-to-top').fadeIn(600);
        }
        else
        {
            $('.scroll-to-top').fadeOut(600);
        }

        if(posScroll >= 70)
        {
            $('body').addClass("top-menu");
        }
        else
        {
            $('body').removeClass("top-menu");
        }

        var windowHeight = $( window ).height();
        var headerHeight = $('header').outerHeight();
        var bannerHeight = $( '.banner-pp, .slide-pp' ).outerHeight();
        var sidebarHeight = $( '.sidebar' ).outerHeight();
        if (bannerHeight === null) bannerHeight = 0;

        var pos = headerHeight + bannerHeight + 10;

        if ((posScroll - pos  + ((windowHeight - sidebarHeight) / 2)) > 0 ) pos = posScroll + ((windowHeight - sidebarHeight )/ 2);
        $( '.sidebar' ).css('top', pos +'px');
        $( '.sidebar' ).css('opacity', 1);

    }


    function scrollInit() {
        var goscroll = false;
        var the_hash = $(location).attr('href');
        var regex = new RegExp("(.*)\#(.*)", "gi");
        var the_element = '';
        if (the_hash.match("\#(.+)")) {
            the_hash = the_hash.replace(regex, "$2");
            try {
                if ($("#" + the_hash).length > 0) {
                    the_element = "#" + the_hash;
                    goscroll = true;
                }
                else if ($("a[name=" + the_hash + "]").length > 0) {
                    the_element = "a[name=" + the_hash + "]";
                    goscroll = true;
                }
                if (goscroll) {
                    var headerHeight = $('header').outerHeight();
                    var to = $(the_element).offset().top - headerHeight - 20;
                    $('html, body').animate({
                        scrollTop: to
                    }, 750);
                    return false;
                }
            }
            catch (e) {
            }
        }
    };


    //********** Validation formulaire ajax ********************//
    $(document).on('submit', 'form[ajax]', function (e) {
        const container = $(e.target).parent();
        const formData = new FormData(this);

        e.preventDefault();
        if ($(this).find('[type="submit"]').hasClass('disabled')) return;
        $(container).addClass('loading');
        $(container).find('.form-error').html('').removeClass("in");
        $(container).find('.form-success').html('').removeClass("in");
        $.ajax({
            type: 'POST',
            url: $(this).attr('action'),
            data: formData,
            processData: false,
            contentType: false,
        })
            .done(function (data) {
                $(container).removeClass('loading');
                if (typeof data.form !== 'undefined') {
                    container.html(data.form);
                }
                if ((typeof data.url !== 'undefined') && (data.url !== null) && (data.url !== '')) {
                    var delay = 0;
                    if ((typeof data.urlDelay !== 'undefined') && (data.urlDelay !== null) && (data.urlDelay !== '')) {
                        delay = data.urlDelay;
                    }
                    setTimeout(function () {
                        window.location.replace(data.url);
                    }, delay);

                } else
                if ((typeof data.change !== 'undefined') && (data.change === 1)) {
                    window.location.reload();
                }
                if ((typeof data.disabled !== 'undefined') && (data.disabled === 1)) {
                    $(container).find('[type="submit"]').addClass('disabled');
                }
                if ((typeof data.msgko !== 'undefined')) {
                    $(container).find('.form-error').html(data.msgko);
                    if (data.msgko === '')
                        $(container).find('.form-error').removeClass('in');
                    else
                        $(container).find('.form-error').addClass('in');
                }
                if ((typeof data.msgok !== 'undefined')) {
                    $(container).find('.form-success').html(data.msgok);
                    if (data.msgok === '')
                        $(container).find('.form-success').removeClass('in');
                    else
                        $(container).find('.form-success').addClass('in');
                }
                if ((typeof data.replaceId !== 'undefined') && (data.replaceId !== '')) {
                    if ((typeof data.replaceContent !== 'undefined') && (data.replaceContent !== '')) {
                        $(data.replaceId).replaceWith(data.replaceContent);
                    }
                }
                if ((typeof data.autoclose !== 'undefined')) {
                    setTimeout(function () {
                        container.closest(".modal").modal('hide');
                    }, data.autoclose);
                }
                if ((typeof data.scrollTo !== 'undefined') && (data.scrollTo !== '')) {
                    $('html, body').animate({
                        scrollTop: $(data.scrollTo).offset().top
                    }, 750);
                }
                if ((typeof data.callback !== 'undefined') && (data.callback !== '')) {

                    var function_name = ""+data.callback;
                    if (function_name=='afterAdPopup') afterAdPopup();
                }
            })
            .fail(function (/* jqXHR, textStatus, errorThrown */) {
                $(container).removeClass('loading');
            });
    });




    //********** Hauteur minimum pour la page ******************//

    $( window ).resize(function() {
        pageResize();
    });
    pageResize();
    scrollFunction();

    function pageResize() {
        /*
        $('.js-advanced-select').select2();
        $('.js-advanced-select-theme1').select2({
            theme: "theme1"
        });
        $('.js-advanced-select-theme2').select2({
            theme: "theme2"
        });
        $('.js-advanced-select-placeholder-theme1').select2({
            placeholder: "Tout critère",
            theme: "theme1"
        });
        $('.js-advanced-select-placeholder-theme2').select2({
            placeholder: "Tout critère",
            theme: "theme2"
        });
         */
        var windowHeight = $( window ).height();
        var headerHeight = $('header').outerHeight();
        var footerHeight = $('footer').outerHeight();
        var mainHeight = windowHeight  - footerHeight - headerHeight;
        $('main').css('min-height', mainHeight + 'px');
    }


    if ($.fancybox !== undefined) {
        $(".fancybox").fancybox();
    }
    if($().tooltip !== undefined) {
        $('[data-toggle="tooltip"]').tooltip({
            html:true,
            //delay: { "show": 500, "hide": 100000 }
        });
        $('[data-toggle="tooltipHtml"]').tooltip({
            html:true,
            //delay: { "show": 500, "hide": 100000 }
        });
    }



    $( document ).ajaxComplete(function() {
        $('.js-advanced-select').select2();
        $('.js-advanced-select-theme1').select2({
            theme: "theme1"
        });
        $('.js-advanced-select-theme2').select2({
            theme: "theme2"
        });
        $('.js-advanced-select-placeholder-theme1').select2({
            placeholder: "Tout critère",
            theme: "theme1"
        });
        $('.js-advanced-select-placeholder-theme2').select2({
            placeholder: "Tout critère",
            theme: "theme2"
        });
        $('.js-advanced-select-placeholder-theme3').select2({
            placeholder: "Selectionner",
            theme: "theme3"
        });
        if ($.fancybox !== undefined) {
            $(".fancybox").fancybox();
        }
        if($().tooltip !== undefined) {
            $('[data-toggle="tooltip"]').tooltip({
                html:true,
                //delay: { "show": 500, "hide": 100000 }
            });
        }
    });




    //********** Menu ******************************************//
    var inMenu = false;
    var inSubMenu = false;

    $('.btn-navbar').click(function (e) {
        e.preventDefault();
        $('.header-navbar').toggleClass('out');
    });



    /*
    $('.header-navbar .level0 > .has-children').hover(function(){
        var content = $(this).find("> ul").html();
        $('#header-navbar-submenu .header-navbar-submenu-container').html(content);
        $('#header-navbar-submenu').collapse('show');
        inMenu = true;

    }, function(){
        inMenu = false;
        setTimeout(function(){
            if (!inSubMenu) {
                $('#header-navbar-submenu').collapse('hide');
            };
        }, 100);
    });


    $('#header-navbar-submenu').hover(function(){
        inSubMenu = true;
    }, function(){
        inSubMenu = false;
        console.log("out subMenu ");
        setTimeout(function(){
            if (!inMenu) {
                $('#header-navbar-submenu').collapse('hide');
            };
        }, 100);
    });
    */

    //********** Animate Number ********************************//
    if ($.animateNumber !== undefined) {
        var comma_separator_number_step = $.animateNumber.numberStepFactories.separator(' ');
        $(".statistics-pp span.value").each(function () {
            var n = $(this).attr('att-value');
            var id = '#' + $(this).attr('id');
            $(id).animateNumber({number: n, easing: 'easeInQuad', numberStep: comma_separator_number_step}, 2000);
        });
    }



    //********** Module Map ************************************//

    var moduleMap;
    var moduleTbmarkers = [];
    var moduleGeo;

    function initModuleMap(geo) {
        moduleGeo = geo;

        moduleMap = L.map('module-map', {scrollWheelZoom: false}).setView([geo.moduleLat, geo.moduleLng], 15);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(moduleMap);

        var icon = L.icon({
            iconUrl: geo.picto,
            iconSize: [27, 37],
            iconAnchor: [14, 37],
        });


        $.each(geo.pois, function(key, val) {
            var icon = L.icon({
                iconUrl: val.icon,
                iconSize: [27, 37],
                iconAnchor: [14, 37],
            });

            var marker = L.marker(  [val.lat, val.lng],
                                    {icon: icon}
                                    ).addTo(moduleMap);

            marker.customInfo = val.typeId;
            marker.bindTooltip(val.name,{className: 'custom-tooltip'});

            if (!val.visible) {
                moduleMap.removeLayer(marker);
            }

            moduleTbmarkers.push(marker);


        });

        var marker = L.marker([geo.moduleLat, geo.moduleLng],{icon:icon}).addTo(moduleMap);

        $(".poi-groups input[type='checkbox']").click(function(){
            var state = $(this).is(":checked");
            var id = $(this).attr('att-type-id');
            $.each(moduleTbmarkers, function (key, val) {
                if (val.customInfo == id) {
                    if (state) {
                        moduleMap.addLayer(val);
                    } else {
                        moduleMap.removeLayer(val);
                    }
                }
            });
        });

        function fromLatLngToPoint(latLng, map) {
            var topLeft = map.containerPointToLatLng([0, 0]);
            var bottomRight = map.containerPointToLatLng([map.getSize().x, map.getSize().y]);
            var scale = Math.pow(2, map.getZoom());
            var point = map.latLngToContainerPoint(latLng);
            var pixelX = (point.x - map.latLngToContainerPoint(bottomRight).x) * scale;
            var pixelY = (point.y - map.latLngToContainerPoint(topLeft).y) * scale;
            return new L.Point(pixelX, pixelY);
        }
    }


    //********** Residency Map ************************************//
    var residencyMap;
    var residencyTbmarkers = [];
    var residencyGeo;

    function initResidencyMap(geo) {
        residencyGeo = geo;

        residencyMap = L.map('residency-map', {scrollWheelZoom: false}).setView([geo.residencyLat, geo.residencyLng], 15);
        L.tileLayer('https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png', {
            attribution: '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
        }).addTo(residencyMap);

        var icon = L.icon({
            iconUrl: geo.picto,
            iconSize: [27, 37],
            iconAnchor: [14, 37],
        });


        $.each(geo.pois, function(key, val) {
            var icon = L.icon({
                iconUrl: val.icon,
                iconSize: [27, 37],
                iconAnchor: [14, 37],
            });

            var marker = L.marker(  [val.lat, val.lng],
                {icon: icon}
            ).addTo(residencyMap);

            marker.customInfo = val.typeId;
            marker.bindTooltip(val.name,{className: 'custom-tooltip'});

            if (!val.visible) {
                residencyMap.removeLayer(marker);
            }

            residencyTbmarkers.push(marker);

        });

        var marker = L.marker([geo.residencyLat, geo.residencyLng],{icon:icon}).addTo(residencyMap);

        $(".poi-groups input[type='checkbox']").click(function(){
            var state = $(this).is(":checked");
            var id = $(this).attr('att-type-id');
            $.each(residencyTbmarkers, function (key, val) {
                if (val.customInfo == id) {
                    if (state) {
                        residencyMap.addLayer(val);
                    } else {
                        residencyMap.removeLayer(val);
                    }
                }
            });
        });


        function fromLatLngToPoint(latLng, map) {
            var topLeft = map.containerPointToLatLng([0, 0]);
            var bottomRight = map.containerPointToLatLng([map.getSize().x, map.getSize().y]);
            var scale = Math.pow(2, map.getZoom());
            var point = map.latLngToContainerPoint(latLng);
            var pixelX = (point.x - map.latLngToContainerPoint(bottomRight).x) * scale;
            var pixelY = (point.y - map.latLngToContainerPoint(topLeft).y) * scale;
            return new L.Point(pixelX, pixelY);
        }

    }




    function openModalModule(id) {
        $("#moduleModal").modal('show');
        var wrapper = $("#moduleModal .modal-wrapper");
        $("#moduleModal").addClass('loading');
        wrapper.html('');
        var route = $(wrapper).attr('data-route');

        if (route != "") {
            $.ajax({
                type: 'POST',
                url: route+"?module="+id,
                contentType: "application/json",
                dataType: 'json',
                success: function(data) {
                    if ((typeof data.result !== 'undefined') && (data.result == 1)) {
                        wrapper.html(data.content);
                        initModuleMap(data.geo);
                    }
                    $("#moduleModal").removeClass('loading');
                },
                error: function(e) {
                    $("#moduleModal").removeClass('loading');
                }
            });
        }
    }

    $(document).on('click', '.btn--modal-module', function(e) {
        e.preventDefault();
        var id = $(this).attr('att-module');
        openModalModule(id);
        return false;
    });


    function openModalResidency(id) {
        $("#residencyModal").modal('show');
        var wrapper = $("#residencyModal .modal-wrapper");
        $("#residencyModal").addClass('loading');
        wrapper.html('');
        var route = $(wrapper).attr('data-route');

        if (route != "") {
            $.ajax({
                type: 'POST',
                url: route+"?residency="+id,
                contentType: "application/json",
                dataType: 'json',
                success: function(data) {
                    if ((typeof data.result !== 'undefined') && (data.result == 1)) {
                        wrapper.html(data.content);
                        initResidencyMap(data.geo);
                    }
                    $("#residencyModal").removeClass('loading');
                },
                error: function(e) {
                    $("#residencyModal").removeClass('loading');
                }
            });
        }
    }

    $(document).on('click', '.btn--modal-residency', function(e) {
        e.preventDefault();
        var id = $(this).attr('att-residency');
        openModalResidency(id);
        return false;
    });


    $('#openModalModule').each(function(){
        var id = $(this).attr('att-module');
        openModalModule(id);
    });



    $(document).on('click', '.btn--modal-module-contact', function(e) {
        e.preventDefault();
        var id = $(this).attr('att-module');
        openModalModuleContact(id);
        return false;
    });


    function openModalModuleContact(id) {
        $("#moduleContactModal").modal('show');
        var wrapper = $("#moduleContactModal .modal-wrapper");
        $("#moduleContactModal").addClass('loading');
        wrapper.html('');
        var route = $(wrapper).attr('data-route');

        if (route != "") {
            $.ajax({
                type: 'GET',
                url: route+"?module="+id,
                contentType: "application/json",
                dataType: 'json',
                success: function(data) {
                    if ((typeof data.result !== 'undefined') && (data.result == 1)) {
                        wrapper.html(data.form);
                    }
                    $("#moduleContactModal").removeClass('loading');
                    refreshModuleContactForm();

                },
                error: function(e) {
                    $("#moduleContactModal").removeClass('loading');
                }
            });
        }
    }



    function refreshModuleContactForm (){
        if($('#module_contact_lodger').prop('checked') == true)
        {
            $('#module_contact_contract').show();

            var placeholder = $('#module_contact_address').attr('placeholder');
            if (placeholder != undefined) {
                placeholder = placeholder.replace('*', '');
                placeholder += '*';
                $('#module_contact_address').attr('placeholder', placeholder);
            }

            placeholder = $('#module_contact_zipCode').attr('placeholder');
            if (placeholder != undefined) {
                placeholder = placeholder.replace('*', '');
                placeholder += '*';
                $('#module_contact_zipCode').attr('placeholder', placeholder);
            }

            placeholder = $('#module_contact_city').attr('placeholder');
            if (placeholder != undefined) {
                placeholder = placeholder.replace('*', '');
                placeholder += '*';
                $('#module_contact_city').attr('placeholder', placeholder);
            }
        }
        else
        {
            $('#module_contact_contract').hide();

            var placeholder = $('#module_contact_address').attr('placeholder');
            if (placeholder != undefined) {
                placeholder = placeholder.replace('*', '');
                $('#module_contact_address').attr('placeholder', placeholder);
            }

            placeholder = $('#module_contact_zipCode').attr('placeholder');
            if (placeholder != undefined) {
                placeholder = placeholder.replace('*', '');
                $('#module_contact_zipCode').attr('placeholder', placeholder);
            }

            placeholder = $('#module_contact_city').attr('placeholder');
            if (placeholder != undefined) {
                placeholder = placeholder.replace('*', '');
                $('#module_contact_city').attr('placeholder', placeholder);
            }
        }

        if($('#module_contact_contactBy_1').prop('checked') == true)
        {
            $('#module_contact_day').show();
            $('#module_contact_horary').show();
        }
        else
        {
            $('#module_contact_day').hide();
            $('#module_contact_horary').hide();
        }


        if ($('#module_contact_day option:selected').val() == 'lundi') {
            $('#module_contact_horary option[value="Après-midi"]').attr('disabled', 'disabled');
        } else {
            $('#module_contact_horary option[value="Après-midi"]').removeAttr('disabled');
        };

        if($('#module_contact_valid').prop('checked') == true) {
            $('#moduleContactModal button[type="submit"]').removeAttr('disabled');

        } else {
            $('#moduleContactModal button[type="submit"]').attr('disabled', 'disabled');
        }


        $('.js-advanced-select').select2();

    }






    $(document).on('click', '#module_contact_lodger', function() {
        refreshModuleContactForm();
        if($('#module_contact_lodger').prop('checked') == true) {
            $("#moduleContactLodgerInfoModal").modal('show');
        }
    });

    $(document).on('click', '#module_contact_valid', function() {
        refreshModuleContactForm();
        if($('#module_contact_valid').prop('checked') == true) {
            $("#moduleContactLegalInformationModal").modal('show');
        }
    });

    $(document).on('click', '#module_contact_contactBy_0,#module_contact_contactBy_1', function() {
        refreshModuleContactForm();
    });

    $(document).on('change', '#module_contact_day', function() {
        if ($('#module_contact_day option:selected').val() == 'Lundi') {
            $('#module_contact_horary option[value="Après-midi"]').attr('disabled', 'disabled');
        } else {
            $('#module_contact_horary option[value="Après-midi"]').removeAttr('disabled');
        };
        $('select#module_contact_horary').select2();
    });

    $(document).on('change', '#module_contact_changeReason', function() {
        var id = $('#module_contact_changeReason option:selected').val();
        $('.changeReasonDescription > div').addClass("hidden");
        if (id > 0) {
            $('#changeReason'+id).removeClass("hidden");
        }
    });

    $( document ).ajaxComplete(function() {
        refreshModuleContactForm();
    });


    $(document).on('show.bs.modal', '.modal', function () {
        var zIndex = 1040 + (10 * $('.modal:visible').length);
        $(this).css('z-index', zIndex);
        setTimeout(function() {
            $('.modal-backdrop').not('.modal-stack').css('z-index', zIndex - 1).addClass('modal-stack');
        }, 0);
    });

    $(document).on('hidden.bs.modal', '.modal', function () {
        $('.modal:visible').length && $(document.body).addClass('modal-open');
    });


    $('.chatbot').on('click', 'a', function() {
        if ($(this).hasClass('active')) {
            $('#sntch_webchat').addClass('in');
            const iframe = document.getElementById('sntch_webchat').querySelector('iframe');
            iframe.contentWindow.postMessage('start', '*');
            setTimeout(function() {
                document.getElementById('sntch_close').setAttribute('style', 'color: #BC0652')
            }, 300);
        }
        return false;
    });

    $(document).on('click', '#sntch_close', function() {
        $('#sntch_webchat').removeClass('in');
        return false;
    });


    if ($.vidbacking !== undefined) {
        $('.video-back').vidbacking();
        AOS.init(
            {
                easing: 'ease',
                duration: 1000,
            }
        );
    }


    $(document).on('click', 'a.disabled', function() {
        return false;
    });

    scrollInit();

    var adPopup = document.getElementById('adPopupModal');
    if (adPopup) {
        var dataId = $('#adPopupModal').attr('data-id');
        var reg = new RegExp('adpopup-' + dataId + '-cookie');
        var hasCookies = document.cookie.match(reg);
        if ((hasCookies === null || typeof hasCookies === 'undefined' || hasCookies === 'false')) {
            $('#adPopupModal').modal('show')
        }
    }

    function afterAdPopup() {
        var dataId = $('#adPopupModal').attr('data-id');
        document.cookie = 'adpopup-' + dataId + '-cookie=true; expires=Fri, 31 Dec 9999 23:59:59 GMT; path=/';
    }


    //********** Search *****************************************//
    function searchHabitationTypeChange() {
        var nb = 0;
        var pro = false;
        $('select#search_habitationType :selected').each(function(){
            if ($(this).text().includes('pro')) pro = true;
            nb++;
        });
        var theme = 'theme1';
        if ($('select#search_rooms').hasClass('js-advanced-select-placeholder-theme2')) theme = 'theme2';
        if (pro && (nb === 1)) {
            $('select#search_rooms').val(null).attr('disabled', 'disabled').select2({
                placeholder: "Tout critère",
                theme: theme
            });
        } else {
            $('select#search_rooms').removeAttr('disabled').select2({
                placeholder: "Tout critère",
                theme: theme
            });
        }
    }
    $(document).on('change.select2','select#search_habitationType',  function(){
        searchHabitationTypeChange();
    });
    searchHabitationTypeChange();



    //********** Search *****************************************//
    function searchAgencyChange() {
        var theme = 'theme1';
        if ($('select#search_district').hasClass('js-advanced-select-placeholder-theme2')) theme = 'theme2';

        var terms = [];
        $('select#search_agency :selected').each(function(){
            terms.push($(this).val());
        });
        terms = terms.join();

        $.ajax({
            type: 'GET',
            url: '/json/modules/search/district',
            contentType: "application/json",
            dataType: 'json',
            data: $.param({'terms' : terms}),
            success: function(data) {
                if (typeof data.results !== 'undefined') {

                    var items = [];
                    var terms = [];
                    $('select#search_district :selected').each(function(){
                        terms.push($(this).val());
                    });
                    data.results.forEach(function(d){
                        if (terms.indexOf(d.id) != -1 ) {
                            items.push({'id': d.id, 'text': d.text, 'selected' : true });
                        } else {
                            items.push({'id': d.id, 'text': d.text});
                        }

                    });
                    var $select = $('select#search_district');

                    $select.select2().empty();
                    $select.select2({
                        data: items,
                        cache: false,
                        placeholder: "Tout critère",
                        theme: theme,
                        language: "fr"
                    });
                }
            },
            error: function(e) {
            }
        });
    }

    $(document).on('change.select2','select#search_agency',  function(){
        searchAgencyChange();
    });
    searchAgencyChange();


    $('.main-header a[href="#"]:not(disabled)').on('click', function() {
        return false;
    });
});

